import dayjs from "dayjs";

export function deepEqual(object1: any, object2: any) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        const areDates = val1 instanceof Date && val2 instanceof Date
        // console.log("dates:", areDates)
        if (
            areDates && !dayjs(val1).isSame(dayjs(val2)) ||
            (!areDates && areObjects) && !deepEqual(val1, val2) ||
            !areObjects && val1 !== val2
        ) {
            return false;
        }
    }
    return true;
}
export function isObject(object: object) {
    return object != null && typeof object === 'object';
}